// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"

// Components
import CopyContainer from "./components/CopyContainer"
// import FormContainer from "./components/FormContainer"

// Styles

const Section = styled.section`
  margin-top: 100px;
  margin-bottom: 100px;
`

export default function Contact() {
  return (
    <Section>
      <BaseContainer>
        <CopyContainer />
      </BaseContainer>
    </Section>
  )
}
